/**
 * Created by jake on 7/14/17.
 */


var unusedSlides = [
	{
		"class": "research",
		"calloutClass": "",
		"headline": "Because great discoveries happen when you least expect them",
		"penImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/Blk-Yel_Open.png?v=107339367169834070711498156867",
		"tagline": "The Pen That Fits <strong>Research</strong>",
		"bugImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/trees.svg?v=48238566260839296141498156722",
		"expandoImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/expando-research_350x.png?v=102650334628323278191498156779",
		"backgroundImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/indexBckd_64954571_1200x.jpg?v=179374179262590863431498156857"
	},
	{
		"class": "school",
		"calloutClass": "left",
		"headline": "Pokka is the pen that makes the grade",
		"penImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/ClearSapphire_Open.png?v=141451834721027687751499439777",
		"tagline": "The Pen That Fits <strong>School</strong>",
		"bugImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/building.svg?v=31836835941773699261498156845",
		"expandoImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/expando-school_350x.png?v=33229471093126284021498156848",
		"backgroundImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/indexBckd_000093843235_1200x.jpg?v=14287816568064378471498156843"
	},
	{
		"class": "travel",
		"calloutClass": "",
		"headline": "Killing time is always easier with a killer Pen",
		"penImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/black.png?v=100802834249237805701498156749",
		"tagline": "The Pen That Fits <strong>Travel</strong>",
		"bugImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/plane.svg?v=109941272079200783701498156718",
		"expandoImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/expando-travel_v2_350x.png?v=172389819752307377471499278763",
		"backgroundImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/indexBckd_64239111_1200x.jpg?v=147594322164864414011498156772"
	},
	{
		"class": "hunting",
		"calloutClass": "",
		"headline": "When there's only room for essentials",
		"penImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/orange.png?v=17852728308985181741498156726",
		"tagline": "The Pen That Fits <strong>Hunting</strong>",
		"bugImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/trees.svg?v=48238566260839296141498156722",
		"expandoImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/expando-hunting_350x.png?v=110955203265322743381498156868",
		"backgroundImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/indexBckd_28533588_1200x.jpg?v=145678079632858097171498156837"
	},
	{
		"class": "nurse",
		"calloutClass": "",
		"headline": "Chart a new course – with Pokka",
		"penImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/black.png?v=100802834249237805701498156749",
		"tagline": "The Pen That Fits <strong>Healthcare</strong>",
		"bugImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/medical.svg?v=115127446998722471631498156755",
		"expandoImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/expando-medical_350x.png?v=115407618599901270851498156850",
		"backgroundImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/indexBckd_465065299_1200x.jpg?v=68233645975623196921498156804"
	}
]

var slides = [
	{
		"class": "jeans",
		"calloutClass": "",
		"headline": "The \"perfect\" pocket pen",
		"penImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/orange_350x.png?v=17852728308985181741498156726",
		"tagline": "The Pen That Fits <strong>Your Jeans</strong>",
		"bugImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/logo.svg?v=141916390943629952911498156755",
		"expandoImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/expando-jeans_700x.png?v=106813986296364254341498156864",
		"backgroundImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/indexBckd_shutterstock_306314900_1200x.jpg?v=181660957049317980781498156717",
		"backgroundPosition": "center left",
		"showExpando": true
	},
	{
		"class": "trip",
		"calloutClass": "",
		"headline": "Cross your \"t's\" while you cross country",
		"penImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/Blk-Org_Open_350x.png?v=49954640607275288361498156784",
		"tagline": "The Pen That Fits <strong>Road Trips</strong>",
		"bugImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/wheel.svg?v=49799139278885780991498156690",
		"expandoImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/expando-trip_350x.png?v=150209973156003091301498156784",
		"backgroundImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/indexBckd_91008795_1200x.jpg?v=90935363718389613241498156814",
		"backgroundPosition": "center"
	},
	{
		"class": "coaching",
		"calloutClass": "",
		"headline": "Sometimes you have to \"draw up\" the play",
		"penImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/black_350x.png?v=100802834249237805701498156749",
		"tagline": "The Pen That Fits <strong>Coaching</strong>",
		"bugImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/whistle.svg?v=114527599453135433351498156794",
		"expandoImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/expando-coaching_350x.png?v=153333950439120152861498156782",
		"backgroundImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/indexBckd_79343757_1200x.jpg?v=86098590442049444001498156803",
		"backgroundPosition": "center"
	},
	{
		"class": "hiking",
		"calloutClass": "",
		"headline": "The perfect companion on a hike or trek",
		"penImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/Kryp_Open_350x.png?v=182002073925630930911498156791",
		"tagline": "The Pen That Fits <strong>Hiking</strong>",
		"bugImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/mtns.svg?v=177816358911375215181498156803",
		"expandoImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/expando-hiking_350x.png?v=82172605750992303001498156855",
		"backgroundImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/indexBckd_80086407_1200x.jpg?v=114148351874061282661498156812",
		"backgroundPosition": "center"
	},
	{
		"class": "work",
		"calloutClass": "left",
		"headline": "Because \"work\" doesn't always mean \"office\"",
		"penImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/brown_350x.png?v=55354686796507471601498156840",
		"tagline": "The Pen That Fits <strong>Work</strong>",
		"bugImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/laptop.svg?v=54613991026650630441498156777",
		"expandoImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/expando-work_350x.png?v=154794631118333477471498156861",
		"backgroundImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/indexBckd_511191892_1200x.jpg?v=120777559172815187341498156816",
		"backgroundPosition": "center"
	},
	{
		"class": "contractor",
		"calloutClass": "left",
		"headline": "The Pokka Pen is built for construction",
		"penImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/black_350x.png?v=100802834249237805701498156749",
		"tagline": "The Pen That Fits <strong>Contracting</strong>",
		"bugImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/hard-hat.svg?v=83365063127124184411498156747",
		"expandoImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/expando-contractor_350x.png?v=61590013420813133271498156784",
		"backgroundImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/indexBckd_93643585_1200x.jpg?v=174253120960194426541498156798",
		"backgroundPosition": "center"
	},
	{
		"class": "kids",
		"calloutClass": "",
		"headline": "Pokkas are fun to mix, match and collect",
		"penImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/ClearSapphire_Open_350x.png?v=141451834721027687751499439777",
		"tagline": "The Pen That Fits <strong>Kids</strong>",
		"bugImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/kid.svg?v=97692102474229489581499278196",
		"expandoImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/expando-kids_350x.png?v=107880044310270341221499277283",
		"backgroundImage": "//pokkapensdev.myshopify.com/cdn/shop/t/2/assets/indexBckd_501513374-edit_1200x.jpg?v=41462425364619758821499275588",
		"backgroundPosition": "center left"
	}
];

var slideIndex = 0;
var images = [];

$(function() {
	loadSlide();

	slides.forEach(function(slide) {
		images.push(slide.penImage);
		images.push(slide.backgroundImage);
	});
});

$(window).load(function() {
	setTimeout(function() {
		var promises = [];

		for (var i = 0; i < images.length; i++) {
			(function(url, promise) {
				var img = new Image();
				img.onload = function() {
					promise.resolve();
				};
				img.src = url;
			})(images[i], promises[i] = $.Deferred());
		}

		$.when.apply($, promises).done(function() {
			setInterval(function() {
				loadSlide();
			}, 3000);
		});
	}, 500);
});

function loadSlide() {
	// var randSlide = Math.floor(Math.random() * slides.length);
	if (slideIndex == slides.length) {
		slideIndex = 0;
	}

	var slide = slides[slideIndex];

	// $("#home .random-slide").attr("class", "random-slide").addClass(slide.class);
	$("#home .random-slide").css({"background-image": "url(" + slide.backgroundImage + ")", "background-position": slide.backgroundPosition});
	$("#home .random-slide").find(".callout").attr("class", "callout").addClass(slide.calloutClass);
	$("#home .random-slide").find("h1").html(slide.headline);
	$("#home .random-slide").find(".pen").attr("src", slide.penImage);
	$("#home .random-slide").find(".bug").attr("src", slide.bugImage);
	$("#home .random-slide").find(".tag-copy").html(slide.tagline);

	if (slide.showExpando) {
		$("#home .random-slide").find(".expando img").attr("src", slide.expandoImage);
		$("#home .random-slide").find(".expando").slideDown(300);
		$("#home .random-slide").find(".callout").addClass("higher");
	} else {
		$("#home .random-slide").find(".expando").slideUp(300);
		$("#home .random-slide").find(".callout").removeClass("higher");
	}

	slideIndex++;
}

function preload() {
	for (var i = 0; i < arguments.length; i++) {
		images[i] = new Image();
		images[i].src = preload.arguments[i];
	}
}